import { Component, Inject, ViewChild } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from "@angular/material/dialog";
import { cloneDeep } from "lodash-es";
import { finalize } from "rxjs";

import { EditEventCompositeGQL } from "generated/graphql";

import { invalidateApolloCacheFor } from "core/apollo-cache-invalidator";

import {
  createUpdateCalendarEventInput,
  EventFormState,
} from "app/events/helpers/event-form-state";

import { EventFormComponent } from "../../components/event-form/event-form.component";
import { AnEventSyncOptionsComponent } from "../../components/an-event-sync-options/an-event-sync-options.component";

@Component({
  selector: "app-edit-event-dialog",
  templateUrl: `./edit-event.dialog.html`,
})
export class EditEventDialog {
  @ViewChild("eventFormRef") eventFormRef: EventFormComponent;
  @ViewChild(AnEventSyncOptionsComponent) eventSyncComponent: AnEventSyncOptionsComponent;

  calendarEvent: EventFormState;
  isSubmitting = false;
  errorMessages: string[] = [];
  originalAssignedUsers: string[] = [];

  static open(dialog: MatDialog, config: MatDialogConfig<any>) {
    return dialog.open(EditEventDialog, config);
  }

  constructor(
    private _editEventMutationGQL: EditEventCompositeGQL,
    public dialogRef: MatDialogRef<EditEventDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { eventDetails: EventFormState }
  ) {
    this.calendarEvent = cloneDeep(data.eventDetails);
    this.originalAssignedUsers = cloneDeep(data.eventDetails.assignedUsers);
  }

  close() {
    this.dialogRef.close();
  }

  calendarEventUpdated(event) {
    this.calendarEvent = { id: this.calendarEvent.id, ...event };
  }

  saveClicked() {
    this.isSubmitting = true;
    this.errorMessages = [];
    const { isValid, errorMessages } = this.eventFormRef.validate();

    if (!isValid) {
      this.errorMessages = errorMessages;
      this.isSubmitting = false;
      return;
    }
    // Determine which users were added and removed
    const updatedUsers = this.calendarEvent.assignedUsers;
    const addedUsers = updatedUsers.filter(user => !this.originalAssignedUsers.includes(user));
    const removedUsers = this.originalAssignedUsers.filter(user => !updatedUsers.includes(user));
    // Determine AN event linking
    const selectedANEvent = this.eventSyncComponent.getSelectedANEvent();

    // Update the event
    this._editEventMutationGQL
      .mutate({
        // Required for link AN event input
        calendarEventId: this.calendarEvent.id,
        updateEventInput: createUpdateCalendarEventInput(this.calendarEvent),
        addCalendarEventUsersInput: {
          calendarEventId: this.calendarEvent.id,
          userIds: addedUsers,
        },
        removeCalendarEventUsersInput: {
          calendarEventId: this.calendarEvent.id,
          userIds: removedUsers,
        },
        actionNetworkEventId: selectedANEvent
          ? Number(selectedANEvent.id)
          : null,
        linkToActionNetworkEvent: Boolean(selectedANEvent),
      }, {
        update: (cache) => {
          invalidateApolloCacheFor(cache, c => c.fieldName?.includes('searchCalendarEvents'));
        }
      })
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(() => {
        this.close();
      });
  }
}
